import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Carousel = _resolveComponent("Carousel", true)

  return (_openBlock(), _createBlock(_component_Carousel, {
    ref: "carousel",
    class: _normalizeClass(["carousel", {'show-navs': $props.showNavs, vertical: $options.vertical}]),
    "show-indicators": $props.showNavs,
    "show-navigators": $props.showNavs,
    unstyled: false,
    orientation: $props.orientation
  }, {
    item: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "item", {
        slotProps: slotProps.data
      }, undefined, true)
    ]),
    previcon: _withCtx(() => [
      _createVNode(_component_Icon, {
        icon: $options.vertical ? 'arrow-up' : 'chevron-left',
        width: "1.6rem",
        height: "1.6rem",
        stroke: "var(--gray-600)"
      }, null, 8 /* PROPS */, ["icon"])
    ]),
    nexticon: _withCtx(() => [
      _createVNode(_component_Icon, {
        icon: $options.vertical ? 'arrow-down' : 'chevron-right',
        width: "1.6rem",
        height: "1.6rem",
        stroke: "var(--gray-600)"
      }, null, 8 /* PROPS */, ["icon"])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class", "show-indicators", "show-navigators", "orientation"]))
}